"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { motion } from "motion/react";
import React from "react";
export function TracingBeam(t0) {
  const $ = _c(8);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative w-full", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute left-4 top-0 h-full w-px md:left-8"><motion.div className="h-full w-full bg-gradient-to-b from-[var(--landing-accent-blue)] via-[var(--landing-accent-blue)]/60 to-transparent" initial={{
        scaleY: 0
      }} whileInView={{
        scaleY: 1
      }} viewport={{
        once: true,
        margin: "-50px"
      }} transition={{
        duration: 0.8,
        ease: "easeOut"
      }} style={{
        originY: 0
      }} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <div className="relative ml-12 md:ml-20">{children}</div>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}